<script setup lang="ts">
import type { MutationStatus } from "@tanstack/vue-query";

withDefaults(
  defineProps<{
    savingStatus: MutationStatus;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);
</script>

<template>
  <section v-if="savingStatus == 'error'" class="error">
    Etwas ist schiefgelaufen.
  </section>
  <section v-else-if="savingStatus == 'success'" class="success">
    Gespeichert!
  </section>
  <button
    v-bind="$attrs"
    class="button"
    type="submit"
    :aria-busy="savingStatus == 'pending'"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>
